module.exports = __webpack_public_path__ + "img/procreate-mobile_jp.6281cd0.jpg";